import React, {useCallback} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {UploadForm, CustomerUploadManager} from '@modifi/plugin-documents'

import {uploadFormComponents} from './components'

const propTypes = {
  availableDocumentTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onFileUploaded: PropTypes.func,
  handleFileUploading: PropTypes.func.isRequired,
  handleFileUploaded: PropTypes.func.isRequired,
}
const defaultProps = {
  onFileUploaded: undefined,
}

type ShipmentDocumentUploadFormProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const ShipmentDocumentUploadForm: React.FC<ShipmentDocumentUploadFormProps> = ({
  isDisabled,
  onFileUploaded,
  handleFileUploading,
  handleFileUploaded: handleFileUploadedProp,
  ...restProps
}) => {
  const handleFileAddedToQueue = useCallback(
    (
      managerIdent: string,
      uploadFormIdent: string,
      file: {meta: {containerNumbers: string[]; shipmentDate: string}}
    ) => {
      handleFileUploading(file)
    },
    [handleFileUploading]
  )

  const handleFileUploaded = useCallback(
    (file: {meta: {containerNumbers: string[]; shipmentDate: string}}) => {
      handleFileUploadedProp(file, file?.meta?.containerNumbers ?? [], file?.meta?.shipmentDate)
    },
    [handleFileUploadedProp]
  )

  return (
    <CustomerUploadManager onAddFileToUploadQueue={handleFileAddedToQueue}>
      <UploadForm
        {...restProps}
        // @ts-expect-error wrong typing
        components={uploadFormComponents}
        isDisabled={isDisabled}
        onFileUploaded={handleFileUploaded}
        withoutOther
        withoutCta
        withInstantFileUpload
      />
    </CustomerUploadManager>
  )
}

ShipmentDocumentUploadForm.propTypes = propTypes
ShipmentDocumentUploadForm.defaultProps = defaultProps

export default React.memo(ShipmentDocumentUploadForm)
